// Core
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';

// Instruments
import { dispatcher } from './dispatcher';
import history from 'init/history';

const dev = process.env.NODE_ENV === 'development';

const routerMiddleware = createRouterMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middleware = [
    routerMiddleware,
    sagaMiddleware,
    dispatcher
];

export { middleware, sagaMiddleware, dev };
